import Vue from 'vue'
import { Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import * as api from "../api";
import { normalizeModel, bakeRemoteData, tree, sleep } from "../utils";
import { InputRow, Node } from "../models";
import FormRows from "../parts/FormRows";
import Tab from "../parts/Tab"
import App from "../App"
import { remoteOp } from "../helper";

const confirmMsg = '表单已修改, 是否放弃保存?'

interface UnsetState {
  kind: 'unset';
}

interface ErrorState {
  kind: 'error';
  message: string;
}

interface DoneState {
  kind: 'done';
  model: {[k: string]: any};
  inputs: InputRow[];
  modified: boolean;
}

type State = UnsetState | ErrorState | DoneState

interface ICommand {
  label: string;
  execute(vm: PortalTemplate): void;
}

@Component({
  name: 'PortalTemplate',
  components: { FormRows, Tab },

  beforeRouteUpdate(this: PortalTemplate, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  },

  beforeRouteLeave(this: PortalTemplate, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  }
})
export default class PortalTemplate extends Vue {
  @Prop() root: Node

  nodeId = 0

  node: Node | null = null

  state: State = {kind: 'unset'}

  loading = false

  busy = false

  commands: ICommand[] = []

  executeCommand(command: ICommand) {
    if (this.state.kind === 'done') {
      command.execute(this)
    }
  }

  private _unwatch?: (()=>void)

  get status() {
    return this.state.kind
  }

  get hasModel() {
    return this.state.kind === 'done'
        && this.state.model
        && this.state.inputs
        && this.state.inputs.length !== 0
  }

  get modified() {
    return this.state.kind === 'done' && this.state.modified
  }

  created() {
    this.reset()
  }

  @Watch('$route')
  $routeChanged() {
    this.reset().then(() => {
      let el = this.$el.querySelector('div.content')
      if (el) {
        el.scrollTop = 0
      }
    })
  }

  beforeDestroy() {
    if (this._unwatch) {
      this._unwatch()
    }
  }

  private async reset() {
    if (this._unwatch) {
      this._unwatch()
      this._unwatch = undefined
    }
    this.busy = false
    let nodeId = parseInt(this.$route.params.nodeId)
    this.nodeId = nodeId
    let node = tree.find(this.root, this.nodeId)
    if (!node) {
      this.state = {kind: 'error', message: 'Invalid node id.'}
      return
    }
    this.node = node
    await sleep(0)
    this.loading = true
    try {
      let portalKey = this.$route.params.portalKey
      let result = await api.node.formValues(nodeId, portalKey)
      result.model = Array.isArray(result.model) ? {} : result.model
      this.state = {
        kind: 'done',
        model: normalizeModel(result.model, result.inputs),
        inputs: result.inputs,
        modified: false
      }
      this.loading = false
      let state = this.state
      this._unwatch = this.$watch('state.model', (oldValue, newValue) => {
        if (newValue && oldValue && newValue === oldValue)
          state.modified = true
      }, {deep: true})
    }
    catch (e) {
      this.loading = false
      this.state = {kind: 'error', message: (e as Error).message}
    }
  }

  save() {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    if (!state.modified) {
      if (!confirm('表单似乎未被修改, 是否继续?')) {
        return
      }
    }
    $(':focus', this.$el).blur()
    remoteOp(this, '保存', '表单', async () => {
      // await api.node.update(this.nodeId, bakeRemoteData(state.model, state.inputs))
      await api.invoke('node/update', this.nodeId, bakeRemoteData(state.model, state.inputs), {type: this.node!.type}, false)
      state.modified = false
    })
  }
}


